// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const { MortgagePropertyValueDefined } = require('components/mortgageRequest/mortgageRequestPropertyValue/mortgagePropertyValueDefined/mortgagePropertyValueDefined');
// @actions
const getMortgagePropertyValueDefinedAction = require('actions/mortgageRequest/mortgageRequestPropertyValueDefined');
const getMortgageDataProprietorAction = require('actions/mortgageRequest/mortgageRequestDataProprietor');

class MortgagePropertyValueDefinedView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { requestPropertyValueDefined, mortgageRequestState, requestUserData } = this.props;
        const currentIdExpediente = mortgageRequestState.get('idExpediente');
        requestPropertyValueDefined(currentIdExpediente);
        requestUserData(currentIdExpediente);
    }

    componentWillReceiveProps(nextProps) {
        const hasError = nextProps.mortgagePropertyValueDefined.get('error');
        if (hasError && hasError.getIn(['error', 'status']) === 404) {
            this.props.history.push('/myprofile/mortgage/property-value');
        }
    }

    buildPropertyValueDefined() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const breadCrumbData = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgagePropertyValueDefined-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        return (
            <div className="mortgage-property-value-defined-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadCrumbData}
                                finalTitle={getFinalTitle('mortgagePropertyValueDefined-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <MortgagePropertyValueDefined />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    render() {

        const { mortgagePropertyValueDefined, mortgageRequestDataProprietor } = this.props;
        let content = null;

        if (mortgagePropertyValueDefined.get('isFetching') || mortgageRequestDataProprietor.get('isFetching')) {
            content = (<LoadingSection />);
        } else if (mortgagePropertyValueDefined.get('hasBeenFetched') && mortgageRequestDataProprietor.get('hasBeenFetched')) {
            content = this.buildPropertyValueDefined();
        }
        return content;
    }
}

MortgagePropertyValueDefinedView.propTypes = {
    history: PropTypes.object.isRequired,
    mortgagePropertyValueDefined: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    mortgageRequestUserData: PropTypes.object,
    mortgageRequestDocuments: PropTypes.object,
    requestPropertyValueDefined: PropTypes.func,
    requestUserData: PropTypes.func,
    mortgageRequestDataProprietor: PropTypes.object,
    immGlobalPosition: PropTypes.object.isRequired
};


module.exports.constructor = MortgagePropertyValueDefinedView;

module.exports.MortgagePropertyValueDefinedView = connect(
    state => ({
        mortgagePropertyValueDefined: state.mortgageRequestPropertyValueDefined,
        mortgageRequestState: state.mortgageRequestState,
        mortgageRequestDataProprietor: state.mortgageRequestDataProprietor,
        immGlobalPosition: state.globalPosition,
    }), {
        requestPropertyValueDefined: getMortgagePropertyValueDefinedAction.requestPropertyValueDefined,
        requestUserData: getMortgageDataProprietorAction.requestDataProprietor
    }
)(withRouter(MortgagePropertyValueDefinedView));
